import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

const selectors = {
  block: "[data-card-row]",
};

const togglePagination = (swiper) => {
  const total = swiper.slides.length;
  const perView = swiper.params.slidesPerView;
  const controls = swiper.el.closest('[data-card-row]')?.querySelector('[data-swiper-controls]');

  if (controls) {
    controls.style.display = total <= perView ? 'none' : '';
  }
};

const initSwiper = (container) =>
  new Swiper(container.querySelector(".swiper"), {
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 24,

    breakpoints: {
      640: {
        slidesPerView: 2,
        slidesPerGroup: 2,
      },
      1024: {
        slidesPerView: 3,
        slidesPerGroup: 3,
      },
    },

    navigation: {
      prevEl: container.querySelector('[data-swiper-navigation="prev"]'),
      nextEl: container.querySelector('[data-swiper-navigation="next"]'),
    },

    pagination: {
      el: container.querySelector("[data-swiper-pagination]"),
    },

    on: {
      init: (swiper) => {
        swiper.el.style.opacity = '1';
        togglePagination(swiper);
      },
      breakpoint: (swiper) => {
        togglePagination(swiper);
      }
    }
  });

const initBlock = (block) => {
  Swiper.use([Navigation, Pagination]);
  initSwiper(block);
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    const blocks = document.querySelectorAll(selectors.block);
    blocks?.forEach(initBlock);
  },
  {
    once: true,
  }
);
